module.exports = __webpack_public_path__ + "fonts/Roboto-ThinItalic.5e786dc1.ttf";